import React from 'react';

// Banderas como SVG en lugar de emoji: los emoji de bandera (🇬🇹, 🇨🇷) no se
// renderizan como ícono en Windows salvo que el sistema tenga instalada una
// fuente con soporte de "regional indicator" — en la mayoría de instalaciones
// de Windows/Chrome se ven en blanco o como las dos letras del código. Un SVG
// propio se ve igual en cualquier sistema operativo o navegador.
const PROPORCIONES = { width: 24, height: 16 };

function BanderaGuatemala({ titulo }) {
  return (
    <svg viewBox="0 0 60 40" width={PROPORCIONES.width} height={PROPORCIONES.height} role="img" aria-label={titulo}>
      <rect width="60" height="40" fill="#FFFFFF" />
      <rect width="20" height="40" fill="#4997D0" />
      <rect x="40" width="20" height="40" fill="#4997D0" />
    </svg>
  );
}

function BanderaCostaRica({ titulo }) {
  const alto = 40 / 6;
  return (
    <svg viewBox="0 0 60 40" width={PROPORCIONES.width} height={PROPORCIONES.height} role="img" aria-label={titulo}>
      <rect width="60" height="40" fill="#002B7F" />
      <rect y={alto} width="60" height={alto} fill="#FFFFFF" />
      <rect y={alto * 2} width="60" height={alto * 2} fill="#CE1126" />
      <rect y={alto * 4} width="60" height={alto} fill="#FFFFFF" />
      <rect y={alto * 5} width="60" height={alto} fill="#002B7F" />
    </svg>
  );
}

const BANDERAS_POR_CODIGO = {
  GT: BanderaGuatemala,
  CR: BanderaCostaRica,
};

export default function BanderaPais({ codigo, nombre, className, style }) {
  const Bandera = BANDERAS_POR_CODIGO[codigo];
  if (!Bandera) return null;
  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        borderRadius: '3px',
        overflow: 'hidden',
        border: '1px solid rgba(0,0,0,0.15)',
        boxShadow: '0 0 0 0.5px rgba(0,0,0,0.05)',
        flex: '0 0 auto',
        lineHeight: 0,
        ...style,
      }}
    >
      <Bandera titulo={nombre} />
    </span>
  );
}
